/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';

interface ErrorStateProps {
	error: Error;
}

export default function ErrorState( { error }: ErrorStateProps ) {
	return (
		<div className="job-board__error" role="alert">
			<p className="job-board__error-title">{ __( 'Failed to load open positions', 'ardent' ) }</p>
			<button className="wp-element-button button--small" onClick={ () => window.location.reload() }>
				{ __( 'Retry', 'ardent' ) }
			</button>
		</div>
	);
}
